var characterList = [

    {
        "id" : "albert",

		"diffuseUrl" 		: "//www.tuftandpaw.com/cdn/shop/t/435/assets/albert01.1k.jpg?v=117576919825040666551764776905",
		"alphaUrl" 			: "//www.tuftandpaw.com/cdn/shop/t/435/assets/albert01.1k.alpha.jpg?v=98191794634937323011764776904",
		"displacementUrl"	: "//www.tuftandpaw.com/cdn/shop/t/435/assets/albert01.1k.depth.jpg?v=146128249688433426211764776905",

		"imgWidth"	: 1024,
		"imgHeight"	: 1024,

		"displacementBias"	: -0.25,
		"displacementScale"	: 2.0,

		"scale" : 0.75,

		"tiltX" 	: 0.0,
		"positionY" : 0.0,
		"pivotY"	: 0.0,

		//

		"eyeVisible" : true,

		"eyeUrl"		: "//www.tuftandpaw.com/cdn/shop/t/435/assets/albert01.eye2.jpg?v=17287929398493942871764776907",
		"eyeDepthUrl"	: "//www.tuftandpaw.com/cdn/shop/t/435/assets/albert01.eye2.depth.png?v=155587660882605996441764776906",
		"corneaUrl" 	: "//www.tuftandpaw.com/cdn/shop/t/435/assets/albert01.eye2.cornea.png?v=78235486750692597491764776906",

		"eyeDepthScale" : -0.1,

		//

		"leftEyePosition" 	: [ 19.83, 7.5, 0.15 ],
		"rightEyePosition"	: [ -11.01, 7.5, 2.63 ],

		"leftEyeRotation" 	: [ -0.08, 0.1, 0.1 ],
		"rightEyeRotation"	: [ -0.08, -0.05, 0 ],

		//

		"eyeScale"  : 11.39,
		"eyeScaleZ" : 0.94,

		"corneaIntensity" : 1,
		"corneaScaleZ" : 1.1,

		//

		"leftEyeRotationScaleY"	 	: 3.6,
		"leftEyeRotationOffsetY" 	: -0.05,

		"leftEyeRotationScaleX"		: 3.6,
		"leftEyeRotationOffsetX"	: -0.1,

		//

		"rightEyeRotationScaleY"	: 3.5,
		"rightEyeRotationOffsetY" 	: -0.1,

		"rightEyeRotationScaleX"	: 3.5,
		"rightEyeRotationOffsetX"	: 0,

		//

		"leftCorneaRotationScaleY" 	: 1.5,
		"leftCorneaRotationOffsetY"	: 0.0,

		"leftCorneaRotationScaleX" 	: 1,
		"leftCorneaRotationOffsetX" : 0.0,

		//

		"rightCorneaRotationScaleY"	 : 1.75,
		"rightCorneaRotationOffsetY" : 0.0,

		"rightCorneaRotationScaleX"	 : 1,
		"rightCorneaRotationOffsetX" : 0.0,

		//

		"borderZ" 		: 60,

		"borderRight"	:  146.5,
		"borderLeft"	: -146.5,

		"borderTop" 	:  97,
		"borderBottom"  : -90,

		//

		"label"			: "Albert",

		"labelSize"		: 0.2,
		"labelColor"	: [ 0.55, 1.0, 0.75 ],

		"labelCenter" 	: 22,
		"labelDepth"	: 30,
		"labelHeight"	: -40,

		//

		"headScaleX"	: 1.4,
		"headScaleY"	: 1.4,

		"headVelocity"	: 4.0,

		//

		"srcName"	: "Albert Baby Cat",
		"srcLink"	: "https://www.instagram.com/albertbabycat/",
      	"srcLabel"	: "albertbabycat",
		"srcCount"	: "554k"

	},

    {
        "id" : "hamilton",

		"diffuseUrl" 		: "//www.tuftandpaw.com/cdn/shop/t/435/assets/hamilton13.1k.jpg?v=51618553739005178551764776933",
		"alphaUrl" 			: "//www.tuftandpaw.com/cdn/shop/t/435/assets/hamilton13.1k.alpha.jpg?v=160330842594056403151764776932",
		"displacementUrl"	: "//www.tuftandpaw.com/cdn/shop/t/435/assets/hamilton13.1k.depth.jpg?v=149713128398112946051764776932",

		"imgWidth"	: 1024,
		"imgHeight"	: 1024,

		"displacementBias"	: -0.25,
		"displacementScale"	: 1.5,

		"scale" : 0.5,

		"tiltX" 	: 0.0,
		"positionY" : 0.0,
		"pivotY" 	: 0.0,

		//

		"eyeVisible" : true,

		"eyeUrl"		: "//www.tuftandpaw.com/cdn/shop/t/435/assets/hamilton13.eye2.jpg?v=27816421336581208331764776934",
		"eyeDepthUrl"	: "//www.tuftandpaw.com/cdn/shop/t/435/assets/hamilton13.eye2.depth.png?v=178721329704422965171764776934",
		"corneaUrl" 	: "//www.tuftandpaw.com/cdn/shop/t/435/assets/hamilton13.eye2.cornea.png?v=158026752181514821631764776933",

		"eyeDepthScale" : -0.1,

		//

		"leftEyePosition" 	: [ 14.0, 12.5, 19.0 ],
		"rightEyePosition"	: [-15.5, 13.5, 16.5 ],

		"leftEyeRotation"  	: [ 0.0, 0.0, 0.25 ],
		"rightEyeRotation"	: [ 0.0, 0.0, 0.0 ],

		//

		"eyeScale"  : 10,
		"eyeScaleZ" : 0.94,

		"corneaIntensity" : 1.0,
		"corneaScaleZ" : 1.1,

		//

		"leftEyeRotationScaleY"	 	: 3.2,
		"leftEyeRotationOffsetY" 	: 0.0125,

		"leftEyeRotationScaleX"		: 4.6,
		"leftEyeRotationOffsetX"	: 0.0,

		//

		"rightEyeRotationScaleY"	: 3.2,
		"rightEyeRotationOffsetY" 	: 0.0,

		"rightEyeRotationScaleX"	: 4.5,
		"rightEyeRotationOffsetX"	: 0.0,

		//

		"leftCorneaRotationScaleY" 	: 1.5,
		"leftCorneaRotationOffsetY"	: 0.0,

		"leftCorneaRotationScaleX" 	: 1.0,
		"leftCorneaRotationOffsetX" : 0.05,

		"rightCorneaRotationScaleY"	 : 1.75,
		"rightCorneaRotationOffsetY" : 0.0,

		"rightCorneaRotationScaleX"	 : 1.0,
		"rightCorneaRotationOffsetX" : 0.05,

		//

		"borderZ" 		: 60,

		"borderRight"	:  146.5,
		"borderLeft"	: -146.5,

		"borderTop" 	:  97,
		"borderBottom"  : -90,

		//

		"label"			: "Hamilton",

		"labelSize"		: 0.2,
		"labelColor"	: [ 0.2, 0.75, 0.25 ],

		"labelCenter" 	: 0,
		"labelDepth"	: 35,
		"labelHeight"	: -43,

		//

		"headScaleX"	: 1.25,
		"headScaleY"	: 1.25,

		"headVelocity"	: 4.0,

		//

		"srcName"	: "Hamilton The Hipster Cat",
		"srcLink"	: "https://www.instagram.com/hamilton_the_hipster_cat/",
		"srcLabel"	: "hamilton_the_hipster_cat",
		"srcCount"	: "815k"

	},

    {
        "id" : "hosico",

		"diffuseUrl" 		: "//www.tuftandpaw.com/cdn/shop/t/435/assets/hosico10.1k.jpg?v=6927452477371015991764776939",
		"alphaUrl" 			: "//www.tuftandpaw.com/cdn/shop/t/435/assets/hosico10.1k.alpha.jpg?v=126119111802829189571764776938",
		"displacementUrl"	: "//www.tuftandpaw.com/cdn/shop/t/435/assets/hosico10.1k.depth.jpg?v=100029367148909822251764776938",

		"imgWidth"	: 1080,
		"imgHeight"	: 1079,

		"displacementBias"	: -0.25,
		"displacementScale"	: 1.3,

		"scale" : 0.5,

		"tiltX" 	: 0.0,
		"positionY" : 0.0,
		"pivotY" 	: 0.0,

		//

		"eyeVisible" : true,

		"eyeUrl"		: "//www.tuftandpaw.com/cdn/shop/t/435/assets/hosico10.eye2.jpg?v=33318193714943683251764776940",
		"eyeDepthUrl"	: "//www.tuftandpaw.com/cdn/shop/t/435/assets/hosico10.eye2.depth.png?v=57259207082374269441764776940",
		"corneaUrl" 	: "//www.tuftandpaw.com/cdn/shop/t/435/assets/hosico10.eye2.cornea.png?v=31262839913917097251764776939",

		"eyeDepthScale" : -0.1,

		//

		"leftEyePosition" 	: [  12.5, 18.0, 18.0 ],
		"rightEyePosition"	: [ -12.5, 18.5, 18.5 ],

		"leftEyeRotation"  	: [ -0.08,  0.10, 0.0 ],
		"rightEyeRotation"	: [ -0.08, -0.05, 0.0 ],

		//

		"eyeScale"  : 8,
		"eyeScaleZ" : 0.94,

		"corneaIntensity" : 1.0,
		"corneaScaleZ" : 1.1,

		//

		"leftEyeRotationScaleY"	 	: 3.6,
		"leftEyeRotationOffsetY" 	: 0.0,

		"leftEyeRotationScaleX"		: 4.0,
		"leftEyeRotationOffsetX"	: 0.0,

		//

		"rightEyeRotationScaleY"	: 4.0,
		"rightEyeRotationOffsetY" 	: -0.1,

		"rightEyeRotationScaleX"	: 4.0,
		"rightEyeRotationOffsetX"	: 0.0,

		//

		"leftCorneaRotationScaleY" 	: 1.5,
		"leftCorneaRotationOffsetY"	: -0.1,

		"leftCorneaRotationScaleX" 	: 1.0,
		"leftCorneaRotationOffsetX" : 0.0,

		"rightCorneaRotationScaleY"	 : 1.75,
		"rightCorneaRotationOffsetY" : -0.1,

		"rightCorneaRotationScaleX"	 : 1.0,
		"rightCorneaRotationOffsetX" : 0.1,

		//

		"borderZ" 		: 60,

		"borderRight"	:  146.5,
		"borderLeft"	: -146.5,

		"borderTop" 	:  97,
		"borderBottom"  : -90,

		//

		"label"			: "Hosico",

		"labelSize"		: 0.2,
		"labelColor"	: [ 0.52, 0.75, 0.35 ],

		"labelCenter" 	: 3,
		"labelDepth"	: 35,
		"labelHeight"	: -26,

		//

		"headScaleX"	: 1.25,
		"headScaleY"	: 1.25,

		"headVelocity"	: 4.0,

		//

		"srcName"	: "Hosico Cat",
		"srcLink"	: "https://www.instagram.com/hosico_cat",
		"srcLabel"	: "hosico_cat",
		"srcCount"	: "1.4m"

	},

    {
        "id" : "izzy",

		"diffuseUrl" 		: "//www.tuftandpaw.com/cdn/shop/t/435/assets/izzy06.1k.jpg?v=20853765835842797441764776945",
		"alphaUrl" 			: "//www.tuftandpaw.com/cdn/shop/t/435/assets/izzy06.1k.alpha.jpg?v=178916839098257711951764776944",
		"displacementUrl"	: "//www.tuftandpaw.com/cdn/shop/t/435/assets/izzy06.1k.depth.jpg?v=96904509304650477511764776944",

		"imgWidth"	: 1024,
		"imgHeight"	: 1024,

		"displacementBias"	: -0.25,
		"displacementScale"	: 1.45,

		"scale" : 0.5,

		"tiltX" 	: 0.0,
		"positionY" : 0.0,
		"pivotY"	: 0.0,

		//

		"eyeVisible" : true,

		"eyeUrl"		: "//www.tuftandpaw.com/cdn/shop/t/435/assets/izzy06.eye2.jpg?v=145393439926754983261764776946",
		"eyeDepthUrl"	: "//www.tuftandpaw.com/cdn/shop/t/435/assets/izzy06.eye2.depth.png?v=77534197049388248811764776946",
		"corneaUrl" 	: "//www.tuftandpaw.com/cdn/shop/t/435/assets/izzy06.eye2.cornea.png?v=137660021656904428621764776945",

		"eyeDepthScale" : -0.1,

		//

		"leftEyePosition" 	: [ 18.5, 4.5, 13.2 ],
		"rightEyePosition"	: [ -12.39, 5.49, 11.8 ],

		"leftEyeRotation" 	: [ -0.08, 0.1, 0.09 ],
		"rightEyeRotation"	: [ -0.08, -0.05, 0 ],

		//

		"eyeScale"  : 11.92,
		"eyeScaleZ" : 0.94,

		"corneaIntensity" : 1,
		"corneaScaleZ" : 1.1,

		//

		"leftEyeRotationScaleY"	 	: 3.5,
		"leftEyeRotationOffsetY" 	: 0.05,

		"leftEyeRotationScaleX"		: 4.6,
		"leftEyeRotationOffsetX"	: 0,

		//

		"rightEyeRotationScaleY"	: 3.6,
		"rightEyeRotationOffsetY" 	: 0,

		"rightEyeRotationScaleX"	: 4.5,
		"rightEyeRotationOffsetX"	: 0,

		//

		"leftCorneaRotationScaleY" 	: 1.5,
		"leftCorneaRotationOffsetY"	: 0,

		"leftCorneaRotationScaleX" 	: 1,
		"leftCorneaRotationOffsetX" : 0.05,

		//

		"rightCorneaRotationScaleY"	 : 1.75,
		"rightCorneaRotationOffsetY" : 0,

		"rightCorneaRotationScaleX"	 : 1,
		"rightCorneaRotationOffsetX" : 0.05,

		//

		"borderZ" 		: 60,

		"borderRight"	:  146.5,
		"borderLeft"	: -146.5,

		"borderTop" 	:  97,
		"borderBottom"  : -90,

		//

		"label"			: "Izzy",

		"labelSize"		: 0.2,
		"labelColor"	: [ 0.11, 0.95, 0.8 ],

		"labelCenter" 	: 3.5,
		"labelDepth"	: 35,
		"labelHeight"	: -40.5,

		//

		"headScaleX"	: 1.25,
		"headScaleY"	: 1.25,

		"headVelocity"	: 4.0,

		//

		"srcName"	: "Izzy the Cat",
		"srcLink"	: "https://www.instagram.com/izzyandthefluff/",
		"srcLabel"	: "izzyandthefluff",
		"srcCount"	: "349k"

	},

    {
        "id" : "klaus",

		"diffuseUrl" 		: "//www.tuftandpaw.com/cdn/shop/t/435/assets/klaus09.1k.jpg?v=103509740043730812771764776948",
		"alphaUrl" 			: "//www.tuftandpaw.com/cdn/shop/t/435/assets/klaus09.1k.alpha.jpg?v=13149659819398419991764776947",
		"displacementUrl"	: "//www.tuftandpaw.com/cdn/shop/t/435/assets/klaus09.1k.depth.jpg?v=161717401529730210741764776948",

		"imgWidth"	: 1024,
		"imgHeight"	: 1024,

		"displacementBias"	: -0.25,
		"displacementScale"	: 1.4,

		"scale" : 0.5,

		"tiltX" 	: 0.0,
		"positionY" : 0.0,
		"pivotY" 	: 0.0,

		//

		"eyeVisible" : true,

		"eyeUrl"		: "//www.tuftandpaw.com/cdn/shop/t/435/assets/klaus09.eye2.jpg?v=29564259318164448831764776950",
		"eyeDepthUrl"	: "//www.tuftandpaw.com/cdn/shop/t/435/assets/klaus09.eye2.depth.png?v=169916564553107508731764776949",
		"corneaUrl" 	: "//www.tuftandpaw.com/cdn/shop/t/435/assets/klaus09.eye2.cornea.png?v=9556494550808710251764776949",

		"eyeDepthScale" : -0.1,

		//

		"leftEyePosition" 	: [  9.5, 15.5, 30.5 ],
		"rightEyePosition"	: [-11.5, 17.5, 21.5 ],

		"leftEyeRotation"  	: [ -0.08,  0.10, 0.0 ],
		"rightEyeRotation"	: [ -0.08, -0.05, 0.0 ],

		//

		"eyeScale"  : 7.35,
		"eyeScaleZ" : 0.94,

		"corneaIntensity" : 1.0,
		"corneaScaleZ" : 1.1,

		//

		"leftEyeRotationScaleY"	 	: 3.6,
		"leftEyeRotationOffsetY" 	: -0.05,

		"leftEyeRotationScaleX"		: 3.8,
		"leftEyeRotationOffsetX"	: 0.1,

		//

		"rightEyeRotationScaleY"	: 3.5,
		"rightEyeRotationOffsetY" 	: -0.3,

		"rightEyeRotationScaleX"	: 3.8,
		"rightEyeRotationOffsetX"	: -0.25,

		//

		"leftCorneaRotationScaleY" 	: 1.5,
		"leftCorneaRotationOffsetY"	: 0.0,

		"leftCorneaRotationScaleX" 	: 1.0,
		"leftCorneaRotationOffsetX" : 0.1,

		"rightCorneaRotationScaleY"	 : 1.75,
		"rightCorneaRotationOffsetY" : - 0.1,

		"rightCorneaRotationScaleX"	 : 1.0,
		"rightCorneaRotationOffsetX" : -0.15,

		//

		"borderZ" 		: 60,

		"borderRight"	:  146.5,
		"borderLeft"	: -146.5,

		"borderTop" 	:  97,
		"borderBottom"  : -90,

		//

		"label"			: "Klaus",

		"labelSize"		: 0.2,
		"labelColor"	: [ 0.25, 0.0, 0.75 ],

		"labelCenter" 	: -2,
		"labelDepth"	: 35,
		"labelHeight"	: -35,

		//

		"headScaleX"	: 1.25,
		"headScaleY"	: 1.25,

		"headVelocity"	: 4.0,

		//

		"srcName"	: "Klaus the Cat",
		"srcLink"	: "https://www.instagram.com/TheKlausCat/",
		"srcLabel"	: "TheKlausCat",
		"srcCount"	: "544k"

	},

	{
        "id" : "nala",

		"diffuseUrl" 		: "//www.tuftandpaw.com/cdn/shop/t/435/assets/nala15.1k.jpg?v=44777775756148673701764776955",
		"alphaUrl" 			: "//www.tuftandpaw.com/cdn/shop/t/435/assets/nala15.1k.alpha.jpg?v=118251152765941567011764776954",
		"displacementUrl"	: "//www.tuftandpaw.com/cdn/shop/t/435/assets/nala15.1k.depth.jpg?v=167101446650018944141764776954",

		"imgWidth"	: 1024,
		"imgHeight"	: 1024,

		"displacementBias"	: -0.25,
		"displacementScale"	: 1.1,

		"scale" : 0.5,

		"tiltX" 	: 0.0,
		"positionY" : 0.0,
		"pivotY" 	: 0.0,

		//

		"eyeVisible" : true,

		"eyeUrl"		: "//www.tuftandpaw.com/cdn/shop/t/435/assets/nala15.eye2.jpg?v=89678853929071410351764776956",
		"eyeDepthUrl"	: "//www.tuftandpaw.com/cdn/shop/t/435/assets/nala15.eye2.depth.png?v=7776573886957833941764776956",
		"corneaUrl" 	: "//www.tuftandpaw.com/cdn/shop/t/435/assets/nala15.eye2.cornea.png?v=162341601809753987031764776955",

		"eyeDepthScale" : -0.1,

		//

		"leftEyePosition" 	: [  9.0,  1.0, 24.0 ],
		"rightEyePosition"	: [-20.0, -2.0, 13.0 ],

		"leftEyeRotation"  	: [ -0.08,  0.10, 0.0 ],
		"rightEyeRotation"	: [ -0.08, -0.05, 0.0 ],

		//

		"eyeScale"  : 11,
		"eyeScaleZ" : 0.94,

		"corneaIntensity" : 1.0,
		"corneaScaleZ" : 1.1,

		//

		"leftEyeRotationScaleY"	 	: 3.4,
		"leftEyeRotationOffsetY" 	: -0.1,

		"leftEyeRotationScaleX"		: 5.0,
		"leftEyeRotationOffsetX"	: 0.0,

		//

		"rightEyeRotationScaleY"	: 3.5,
		"rightEyeRotationOffsetY" 	: -0.4,

		"rightEyeRotationScaleX"	: 5.0,
		"rightEyeRotationOffsetX"	: 0.1,

		//

		"leftCorneaRotationScaleY" 	: 1.5,
		"leftCorneaRotationOffsetY"	: -0.2,

		"leftCorneaRotationScaleX" 	: 1.0,
		"leftCorneaRotationOffsetX" : 0.1,

		"rightCorneaRotationScaleY"	 : 1.75,
		"rightCorneaRotationOffsetY" : -0.3,

		"rightCorneaRotationScaleX"	 : 1.0,
		"rightCorneaRotationOffsetX" : 0.1,

		//

		"borderZ" 		: 60,

		"borderRight"	:  146.5,
		"borderLeft"	: -146.5,

		"borderTop" 	:  97,
		"borderBottom"  : -95,

		//

		"label"			: "Nala",

		"labelSize"		: 0.2,
		"labelColor"	: [ 0.55, 0.2, 0.75 ],

		"labelCenter" 	: 20,
		"labelDepth"	: 45,
		"labelHeight"	: -45,

		//

		"headScaleX"	: 1.25,
		"headScaleY"	: 1.25,

		"headVelocity"	: 4.0,

		//

		"srcName"	: "Nala Cat",
		"srcLink"	: "https://www.instagram.com/nala_cat/",
		"srcLabel"	: "nala_cat",
		"srcCount"	: "3.9m"

	},

    {
        "id" : "oskar",

		"diffuseUrl" 		: "//www.tuftandpaw.com/cdn/shop/t/435/assets/oskar06.1k.jpg?v=24193413642855152241764776958",
		"alphaUrl" 			: "//www.tuftandpaw.com/cdn/shop/t/435/assets/oskar06.1k.alpha.jpg?v=174938630412045912401764776957",
		"displacementUrl"	: "//www.tuftandpaw.com/cdn/shop/t/435/assets/oskar06.1k.depth.jpg?v=31571775853586093881764776958",

		"imgWidth"	: 1024,
		"imgHeight"	: 1024,

		"displacementBias"	: -0.25,
		"displacementScale"	: 1.5,

		"scale" : 0.5,

		"tiltX" 	: 0.0,
		"positionY" : 0.0,
		"pivotY" 	: 0.0,

		//

		"eyeVisible" : false,

		"eyeUrl"		: "//www.tuftandpaw.com/cdn/shop/t/435/assets/klaus09.eye2.jpg?v=29564259318164448831764776950",
		"eyeDepthUrl"	: "//www.tuftandpaw.com/cdn/shop/t/435/assets/klaus09.eye2.depth.png?v=169916564553107508731764776949",
		"corneaUrl" 	: "//www.tuftandpaw.com/cdn/shop/t/435/assets/klaus09.eye2.cornea.png?v=9556494550808710251764776949",

		"eyeDepthScale" : -0.1,

		//

		"leftEyePosition" 	: [  0.0, 10.0, 36.0 ],
		"rightEyePosition"	: [  0.0, 10.0, 30.0 ],

		"leftEyeRotation"  	: [ -0.08,  0.10, 0.0 ],
		"rightEyeRotation"	: [ -0.08, -0.05, 0.0 ],

		//

		"eyeScale"  : 1,
		"eyeScaleZ" : 0.94,

		"corneaIntensity" : 0.75,
		"corneaScaleZ" : 1.1,

		//

		"leftEyeRotationScaleY"	 	: 2.6,
		"leftEyeRotationOffsetY" 	: 0.05,

		"leftEyeRotationScaleX"		: 3.0,
		"leftEyeRotationOffsetX"	: 0.25,

		//

		"rightEyeRotationScaleY"	: 2.75,
		"rightEyeRotationOffsetY" 	: -0.1,

		"rightEyeRotationScaleX"	: 3.0,
		"rightEyeRotationOffsetX"	: 0.3,

		//

		"leftCorneaRotationScaleY" 	: 1.5,
		"leftCorneaRotationOffsetY"	: 0.0,

		"leftCorneaRotationScaleX" 	: 1.0,
		"leftCorneaRotationOffsetX" : 0.25,

		"rightCorneaRotationScaleY"	 : 1.75,
		"rightCorneaRotationOffsetY" : - 0.1,

		"rightCorneaRotationScaleX"	 : 1.0,
		"rightCorneaRotationOffsetX" : 0.25,

		//

		"borderZ" 		: 60,

		"borderRight"	:  146.5,
		"borderLeft"	: -146.5,

		"borderTop" 	:  97,
		"borderBottom"  : -90,

		//

		"label"			: "Oskar",

		"labelSize"		: 0.2,
		"labelColor"	: [ 0.03, 0.75, 0.75 ],

		"labelCenter" 	: 0,
		"labelDepth"	: 35,
		"labelHeight"	: -28,

		//

		"headScaleX"	: 1.25,
		"headScaleY"	: 1.25,

		"headVelocity"	: 4.0,

		//

		"srcName"	: "Oskar the Blind Cat",
		"srcLink"	: "https://www.instagram.com/TheKlausCat/",
		"srcLabel"	: "TheKlausCat",
		"srcCount"	: "544k"

	},

    {
        "id" : "smoothie",

		"diffuseUrl" 		: "//www.tuftandpaw.com/cdn/shop/t/435/assets/smoothie08.1k.jpg?v=13209180509612134211764777047",
		"alphaUrl" 			: "//www.tuftandpaw.com/cdn/shop/t/435/assets/smoothie08.1k.alpha.jpg?v=92092527319330381701764777045",
		"displacementUrl"	: "//www.tuftandpaw.com/cdn/shop/t/435/assets/smoothie08.1k.depth.jpg?v=106373897845358075501764777046",

		"imgWidth"	: 1024,
		"imgHeight"	: 1024,

		"displacementBias"	: -0.25,
		"displacementScale"	: 1.3,

		"scale" : 0.55,

		"tiltX" 	: 0.0,
		"positionY" : 0.0,
		"pivotY"	: 0.0,

		//

		"eyeVisible" : true,

		"eyeUrl"		: "//www.tuftandpaw.com/cdn/shop/t/435/assets/smoothie08.eye2.jpg?v=21998650374607414111764777048",
		"eyeDepthUrl"	: "//www.tuftandpaw.com/cdn/shop/t/435/assets/smoothie08.eye2.depth.png?v=21374015329801408831764777048",
		"corneaUrl" 	: "//www.tuftandpaw.com/cdn/shop/t/435/assets/smoothie08.eye2.cornea.png?v=148033040838007473131764777047",

		"eyeDepthScale" : -0.1,

		//

		"leftEyePosition" 	: [ 11.5, 7.8, 20.5 ],
		"rightEyePosition"	: [ -16.5, 11, 16.2 ],

		"leftEyeRotation" 	: [ -0.08, 0.1, 0.09 ],
		"rightEyeRotation"	: [ -0.08, -0.05, 0 ],

		//

		"eyeScale"  : 10.47,
		"eyeScaleZ" : 0.94,

		"corneaIntensity" : 0.8,
		"corneaScaleZ" : 1.1,

		//

		"leftEyeRotationScaleY"	 	: 3.6,
		"leftEyeRotationOffsetY" 	: 0,

		"leftEyeRotationScaleX"		: 3.6,
		"leftEyeRotationOffsetX"	: 0,

		//

		"rightEyeRotationScaleY"	: 3.5,
		"rightEyeRotationOffsetY" 	: 0,

		"rightEyeRotationScaleX"	: 3.5,
		"rightEyeRotationOffsetX"	: 0,

		//

		"leftCorneaRotationScaleY" 	: 1.5,
		"leftCorneaRotationOffsetY"	: 0.05,

		"leftCorneaRotationScaleX" 	: 1,
		"leftCorneaRotationOffsetX" : 0.1,

		//

		"rightCorneaRotationScaleY"	 : 1.75,
		"rightCorneaRotationOffsetY" : -0.5,

		"rightCorneaRotationScaleX"	 : 1,
		"rightCorneaRotationOffsetX" : 0,

		//

		"borderZ" 		: 60,

		"borderRight"	:  146.5,
		"borderLeft"	: -146.5,

		"borderTop" 	:  97,
		"borderBottom"  : -90,

		//

		"label"			: "Smoothie",

		"labelSize"		: 0.2,
		"labelColor"	: [ 0.4, 0.75, 0.5 ],

		"labelCenter" 	: -2,
		"labelDepth"	: 35,
		"labelHeight"	: -38,

		//

		"headScaleX"	: 1.25,
		"headScaleY"	: 1.25,

		"headVelocity"	: 4.0,

		//

		"srcName"	: "Smoothie the Cat",
		"srcLink"	: "https://www.instagram.com/smoothiethecat/",
		"srcLabel"	: "smoothiethecat",
		"srcCount"	: "1.8m"

	}

];